import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useCarouselNavControlStyles = makeStyles({
    carouselNav: {
        boxSizing: 'border-box',
        display: 'flex',
        float: 'right',
        height: '100%',
    },
    carouselNavDisabled: __assign(__assign({ pointerEvents: 'none', color: tokens.colorNeutralForegroundDisabled }, shorthands.outline('1px', 'dashed', 'transparent')), { outlineOffset: '-1px', ':focus-visible': {
            color: tokens.colorNeutralForegroundDisabled,
        } }),
    carouselNavRefresh: __assign({ backgroundColor: tokens.colorNeutralBackground2 }, shorthands.borderRadius(tokens.borderRadiusMedium)),
    carouselNavBase: __assign(__assign(__assign(__assign(__assign(__assign({ alignItems: 'center' }, shorthands.borderRadius('2px')), { color: tokens.colorNeutralForeground2, cursor: 'pointer', display: 'flex', flexWrap: 'nowrap', height: '100%', justifyContent: 'center' }), shorthands.outline('1px', 'solid', 'transparent')), { outlineOffset: '-1px' }), shorthands.padding(0)), { width: '32px', ':hover': {
            color: tokens.colorNeutralForeground1,
            backgroundColor: tokens.colorNeutralBackground2Hover,
        }, ':focus-visible': {
            color: tokens.colorNeutralForeground1,
            outlineColor: tokens.colorStrokeFocus2,
            outlineStyle: 'auto',
            outlineWidth: '1px',
        }, ':active': {
            backgroundColor: tokens.colorNeutralBackground2Pressed,
            color: tokens.colorNeutralForeground1,
        } }),
});
//# sourceMappingURL=CarouselNavControl.styles.js.map